import store from 'utils/store/withMiddleware'
import getValueSelected from 'utils/DOM/getValueSelected'

function handleSortCombo() {
  const state = store.getState()
  const sortBy = getValueSelected(this)

  if (state.sortBy !== sortBy) {
    store.update({ sortBy })
  }
}

export default handleSortCombo
